import React from "react";
import "./style.css";
import {useState, useRef} from 'react';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {useSmsMutation, useLoginMutation} from '../../store/pageApi2';
import {useSearchParams} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';

const Login = () => {
    const [count] = useSearchParams()
    const [sms] = useSmsMutation()
    const [login] = useLoginMutation()
    const [phone, setPhone] = useState('')
    const [know, setKnow] = useState(true)
    const [num, setNum] = useState(60)
    // 获取验证码和登录共用一处错误显示（提交按钮上方），后来的覆盖先前的。
    // 早先验证码的报错挤在输入框右侧，位置窄、和登录报错分处两地，
    // 用户容易只看到一个
    const [loginError, setLoginError] = useState("")
    const [lang, setLang] = useState('zh')
    const {t, i18n} = useTranslation();
    const [start, setStart] = useState(false)
    const timerRef = useRef(null)
    const nav = useNavigate()

    // 离开页面时清掉倒计时，避免卸载后仍 setState
    useEffect(() => () => clearTimeout(timerRef.current), [])

    useEffect(() => {
        const div = document.documentElement.querySelector('.div2');
        const height=document.documentElement.clientHeight+'px';
        console.log(height+'----height')
        // const body = document.querySelector('body')
        // console.log(window.innerHeight)
        div.style.height = height
        div.style.backgroundImage = 'url(/img/2026-9/bg1.png)'


        const kuang = document.querySelector('.overlap-group-wrapper')
        console.log(kuang)
        console.log(div.style.height+'------div--px')
        if(document.documentElement.clientHeight<1387){
            console.log(div.style.height+'------1')
            const weizhi = 700
            console.log(weizhi)
            console.log(kuang.style.marginTop)
            kuang.style.marginTop = `${weizhi}px`
        }else{
            console.log(div.style.height+'------2')
            const weizhi = document.documentElement.clientHeight/2 +(150*document.documentElement.clientHeight/1688)
            console.log(weizhi)
            console.log(kuang.style.marginTop)
            kuang.style.marginTop = `${weizhi}px`
        }


    }, [])
    useEffect(() => {
        console.log(count.get('lan'))


        if (count.get('lan')) {
            i18n.changeLanguage(count.get('lan'));
            localStorage.setItem('li_lan', count.get('lan'))
            if (count.get('lan') == 'en') {
                document.title = ' Li Auto Global Partners Conference 2026'
            } else {
                document.title = '理想汽车2026全球合作伙伴大会'
            }
        } else {
            console.log('zh');
            i18n.changeLanguage('zh');
            localStorage.setItem('li_lan', 'zh')
            document.title = '理想汽车2026全球合作伙伴大会'

            // if (localStorage.getItem('li_lan')) {
            //   console.log('first')
            //   i18n.changeLanguage(localStorage.getItem('li_lan'));
            //   document.title = ' Li Auto Global Partners Conference 2024'
            //   if(localStorage.getItem('li_lan')=='en'){
            //     document.title = ' Li Auto Global Partners Conference 2024'
            //   }else{
            //     document.title = '理想汽车2024全球合作伙伴大会'
            //   }
            // }else{

            // }
        }

        if (localStorage.getItem('li_token') && localStorage.getItem('li_user_id')) {
            // props.funcLogin()
            nav('/home', {replace: true})
        }

    }, [])


    // 倒计时自驱动：每次只挂一个定时器，到 0 收尾。
    // 早先由 useEffect([num]) 和点击各触发一条链，导致每秒减 2、30 秒就走完，
    // 而后端重发间隔是 60 秒，按钮提前恢复点了必然被拒。
    const tick = () => {
        timerRef.current = setTimeout(() => {
            setNum(state => {
                if (state <= 1) {
                    setStart(false)
                    return 60
                }
                tick()
                return state - 1
            })
        }, 1000)
    }

    const stopCountDown = () => {
        clearTimeout(timerRef.current)
        setStart(false)
        setNum(60)
    }

    const countDown2 = () => {

        setLoginError("")
        // 先本地校验，避免空号/错号也打一次接口
        if (!phoneTest(phone)) {
            setLoginError(t("v_fill_phone"))
            return
        }

        sms({
            phone
        }).then(res => {
            // 网络异常或非 2xx 时 RTK Query 返回 {error}，res.data 为 undefined
            const data = res && res.data
            if (!data) {
                setLoginError(t("v_network_error"))
                stopCountDown()
                return
            }

            if (data.rs == 0) {
                setLoginError(data.msg)
                stopCountDown()

            } else if (data.rs == 3) {
                setKnow(false)
                setLoginError(data.msg)
                stopCountDown()
            } else {
                setStart(true)
                tick()
            }
        });


    }
    const knowItem = () => {

        return (
            <>
                <div className="rectangle"/>
                <div className="overlap-wrapper-2">
                    <div className="overlap-4">
                        <div className="text-wrapper-6">
                            {t("home_form_success")}

                        </div>
                        <img
                            className="image-2"
                            alt="Image"
                            src="/img/login/---.svg"
                        />
                        <button className="text-wrapper-7" onClick={() => {
                            setKnow(true)
                        }}>{t("home_form_success_btn")}
                        </button>
                    </div>
                </div>
            </>
        )
    }
    const phoneTest = function (value) {
        var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;    //11位手机号码正则
        if (
            !reg_tel.test(value)
        ) {
            return false
        } else {
            return true
        }
    }
    const SignupSchema = Yup.object().shape({
        name: Yup.string()
            .required(t("v_fill_name")),
        // 必须是字符串校验：Yup.number() 会把 "012345" 转成 12345，
        // 而后端 padStart(6,'0') 有 10% 概率生成 0 开头的码，那部分用户将永远登录失败
        code: Yup.string()
            .matches(/^\d{6}$/, t("v_fill_code"))
            .required(t("v_fill_code")),
        phone: Yup.string()
            .test('phone', t("v_fill_phone"), phoneTest)
            .required(t("v_fill_phone_require")),
    });

    return (
        <div className="login">
            <div className='div2'>
                <div className="overlap-wrapper">

                    <div className="overlap">
                        {/* <img
            className="element-l"
            alt="Element l"
            src="/img/2024bg1.jpg"
          /> */}
                        <img src={t("is_en") == 1 ? "/img/logo-en.png" : "/img/login/logo.png"} alt=""
                             className="logo"/>
                        <div className="text-wrapper">

                            {t("理想汽车2026")}
                            <br/>
                            {t("全球合作伙伴大会")}
                        </div>

                        <div className="overlap-group-wrapper">
                            <div className="overlap-group">
                                <Formik
                                    initialValues={{
                                        name: '',
                                        phone: '',
                                        code: ''
                                    }}
                                    validationSchema={SignupSchema}
                                    onSubmit={values => {
                                        setLoginError("")
                                        login({
                                            phone: values.phone,
                                            name: values.name,
                                            code: values.code,
                                        }).then(res => {
                                            const data = res && res.data
                                            if (!data) {
                                                setLoginError(t("v_network_error"))
                                                return
                                            }

                                            if (data.rs === 1) {
                                                localStorage.setItem("li_token", data.token)
                                                localStorage.setItem("li_user_id", data.user_id)
                                                // props.funcLogin()
                                                nav('/home', {replace: true})

                                            } else if (data.rs == -1) {
                                                setKnow(false)
                                                setLoginError(data.msg)

                                            } else {
                                                setLoginError(data.msg)

                                            }

                                        });


                                    }}
                                >
                                    {({values, handleChange, handleBlur, errors, touched}) => (
                                        <Form>
                                            <div className="div">
                                                <div className="view">
                                                    <div className="overlap-group-2">
                                                        <img
                                                            className="image"
                                                            alt="Image"
                                                            src="/img/login/--3.svg"
                                                        />
                                                        <div className="text-wrapper-2">{t("home_form_code")}</div>
                                                        <input type="tel" name="code"
                                                               inputMode="numeric"
                                                               maxLength={6}
                                                               value={values.code}
                                                               onChange={handleChange}
                                                               onBlur={handleBlur}
                                                               placeholder={t("home_form_code_placeholder")}
                                                               style={{width: "200px"}}
                                                               className={errors.code && touched.code ?
                                                                   "text-wrapper-3" : "text-wrapper-3"}

                                                        />
                                                        {
                                                            start ? <button className="text-wrapper-4"
                                                                            type="button">{num}</button> :
                                                                <button className="text-wrapper-4" type="button"
                                                                        onClick={countDown2}>{t("home_form_code_btn")}</button>
                                                        }
                                                        {errors.code && touched.code ? (
                                                            <div className='err'>{errors.code}</div>
                                                        ) : null}

                                                        <img
                                                            className="img"
                                                            alt="Image"
                                                            src="/img/login/----4.svg"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="group-2">
                                                    <div className="overlap-2">
                                                        <div className="div-wrapper">
                                                            <div className="overlap-group-3">
                                                                <div
                                                                    className='text-wrapper-2'>{t("home_form_phone")}</div>
                                                                <input type="tel" name="phone"
                                                                       inputMode="numeric"
                                                                       maxLength={11}
                                                                       value={values.phone}
                                                                       onChange={(e) => {
                                                                           handleChange(e);
                                                                           setPhone(e.target.value)
                                                                       }}
                                                                       onBlur={handleBlur}
                                                                       placeholder={t("home_form_phone_placeholder")}
                                                                       className={errors.phone && touched.phone ?
                                                                           "text-wrapper-3" : "text-wrapper-3"}
                                                                />
                                                                {errors.phone && touched.phone ? (
                                                                    <div className='err'>{errors.phone}</div>
                                                                ) : null}

                                                            </div>
                                                        </div>
                                                        <img
                                                            className="img"
                                                            alt="Image"
                                                            src="/img/login/----4.svg"
                                                        />
                                                    </div>
                                                    <div className="div-wrapper">
                                                        <div className="overlap-group-2">
                                                            <img
                                                                className="image"
                                                                alt="Image"
                                                                src="/img/login/--1.svg"
                                                            />
                                                            <img
                                                                className="img"
                                                                alt="Image"
                                                                src="/img/login/----4.svg"
                                                            />
                                                            <div className="text-wrapper-2">{t("home_form_name")}</div>
                                                            <input type="" name="name"
                                                                   value={values.name}
                                                                   onChange={handleChange}
                                                                   onBlur={handleBlur}
                                                                   placeholder={t("home_form_name_placeholder")}
                                                                   className={errors.name && touched.name ?
                                                                       "text-wrapper-3" : "text-wrapper-3"}
                                                            />
                                                            {errors.name && touched.name ? (
                                                                <div className='err'>{errors.name}</div>
                                                            ) : null}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {loginError ? (
                                                <div className='err-login'>{loginError}</div>
                                            ) : null}
                                            <button className="overlap-3" type="submit">
                                                <div className="text-wrapper-5">{t("home_form_submit")}</div>
                                            </button>

                                            <button type='submit'
                                                    className="btn btn-default form-control form-control-login btn-submit "
                                                    style={{
                                                        margin: '20px 0 0px 0',
                                                        color: '#fff',
                                                        textTransform: "uppercase"
                                                    }}
                                            >{t("home_form_submit")}</button>
                                        </Form>
                                    )}
                                </Formik>

                            </div>
                        </div>
                        {
                            know ? null : knowItem()
                        }
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Login
